import { render, staticRenderFns } from "./PatchNotes.vue?vue&type=template&id=163fba1f"
import script from "./PatchNotes.vue?vue&type=script&lang=js"
export * from "./PatchNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports